
import { storage } from "@/plugins/firebase";
import { getDownloadURL, ref } from "firebase/storage";
import Vue from "vue";

interface IImgSrcUrlList {
  [imgSrc: string]: string;
}
export default Vue.extend({
  props: {
    srcList: {
      type: Array as () => string[],
      required: true,
    },
    height: {
      type: Number,
      default: 350,
    },
  },
  data(): {
    imgSrcUrlList: IImgSrcUrlList;
    selectedImgUrl: string;
  } {
    return {
      imgSrcUrlList: {},
      selectedImgUrl: "",
    };
  },
  computed: {
    imgSrcList() {
      return this.srcList;
    },
  },
  async created() {
    if (this.imgSrcList.length == 0) {
      return;
    }
    Promise.all([
      this.setSelectedImg(this.imgSrcList[0]),
      this.setCastImgUrl(this.imgSrcList),
    ]);
  },
  methods: {
    async getImgSrcUrl(imgSrc: string): Promise<string> {
      return await getDownloadURL(ref(storage, imgSrc))
        .then((url: string) => {
          return url;
        })
        .catch((err) => {
          console.log(err);
          return "";
        });
    },
    async setSelectedImg(imgSrc: string) {
      const url = await this.getImgSrcUrl(imgSrc);
      if (this.selectedImgUrl != url) {
        this.selectedImgUrl = await this.getImgSrcUrl(imgSrc);
      }
    },
    async setCastImgUrl(imgSrcList: string[]) {
      await Promise.all(
        imgSrcList.map(async (imgSrc: string) => {
          const url = await this.getImgSrcUrl(imgSrc);
          this.imgSrcUrlList[imgSrc] = url;
        })
      );
    },
  },
});
